import { useEffect, useState } from "react";
import Blocks from "../blocks";
import { useHistory, useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { updateStudentProfile } from "../../api/students";
import moment from "moment";
import { Dialog } from "@headlessui/react";
import SignupBg from "../../assets/images/study-signup.svg";
import { Field, Formik } from "formik";
import UTILS from "../../utils";
import Fields from "../formFields";
import Partials from "../partials";
import { useKeycloak } from "@react-keycloak/web";
import keycloak from "../../keycloak";
import { IoMdArrowBack } from "react-icons/io";
import { toast } from 'react-toastify'; 
const PageEditStudentProfile = () => {
  const history = useHistory();

  const { sid } = useParams();
  const { keycloak } = useKeycloak();
  const studentSid = keycloak?.idTokenParsed?.sid;

  const [isDialogOpen, _setIsDialogOpen] = useState(false);
  const [studentName, _studentName] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [initialValues, _setInitialValues] = useState({
    id: "",
    email: "",
    first_name: "",
    last_name: "",
    dob: "",
    gender: { value: "male", label: "Male" },
    photo: "",
    mobile_number: "",
    countryCode: "",
    countryDial: "",
  });

  useEffect(() => {
    if (studentSid !== sid) {
      history.replace("/login");
    }
  });

  useEffect(() => {
    const studentData = keycloak?.idTokenParsed;
    const DOB = studentData?.dob
      ? moment(Number(studentData?.dob)).format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");

    _studentName(studentData?.given_name);
    const newInitValues = {
      id: studentData.sub,
      email: studentData.email,
      first_name: studentData.given_name,
      last_name: studentData.family_name,
      mobile_number: studentData.phone_number,
      photo: studentData?.photo,
      dob: DOB,
    };

    _setInitialValues({ ...initialValues, ...newInitValues });
  }, []);

  const { isLoading, error, isError, mutate, data } = useMutation(
    updateStudentProfile,
    {
      onSuccess: (data) => {
        // update within a large number of seconds to ensure token is updated
        keycloak
          .updateToken(720000)
          .then(function (refreshed) {
            if (refreshed) {
              toast.success("Profile updated successfully!");
            } else {
              console.log("Token NOT updated after update profile");
            }
          })
          .catch(function () {
            console.log("Error in Token updated after update profile");
          });
        history.push("/student/start-live-class");
      },
      onError: (err) => {
      console.log(err);
      if (err.response?.status >= 400 && err.response?.status < 600) {
        const errorMessage = err.response?.data?.message || 
                           err.message || 
                           "An error occurred while updating your profile";
        setErrorMessage(errorMessage);
        if (err.response?.status >= 500) {
          toast.error(errorMessage);
        }
      }
    },
    }
  );

  const updateProfile = (values) => {
    // Clear any previous error messages
    setErrorMessage("");
    
    const { first_name, last_name, mobile_number, dob, gender, photo, email } =
      values;
    const updatedPhoto = photo.replace("data:", "").replace(/^.+,/, "");
    const studentData = keycloak?.idTokenParsed;
    let mobileNo = "";
    if (mobile_number) {
      mobileNo = `+${values.countryDial}-${mobile_number.slice(
        values.countryDial.length
      )}`;
    }

    const dobValue = UTILS.time.getTimeStamp(dob);

    let student_obj = {
      id: values.id,
      data: {
        first_name,
        last_name,
        mobile_number: mobileNo,
        gender: gender.value,
        dob: dobValue,
      },
    };

    if (studentData?.photo !== updatedPhoto) {
      const newStudent_obj = {
        ...student_obj,
        data: {
          ...student_obj.data,
          photo: updatedPhoto,
        },
      };
      mutate(newStudent_obj);
    } else {
      mutate(student_obj);
    }
  };

  const goToHome = () => {
    history.push("/");
  };

  return (
    <div className={"page PageStudentCompleteProfile"}>
      <div className="container mx-auto">
        <h3
          className={
            "flex justify-center flex-col  md:hidden text-xl text-center pt-16 pb-4 font-['Poppins-Bold']"
          }
        >
          <div className="flex m-auto gap-2">
            <div>
              <IoMdArrowBack
                size={30}
                className="cursor-pointer"
                onClick={() => goToHome()}
              />
            </div>

            <div className="flex flex-col justify-start items-start">
              <h1 className="text-xl break-all font-subheading">Hi, {studentName}</h1>
              <h4 className={"text-xl break-all font-subheading"}>
                {"Edit your student profile"}
              </h4>
            </div>
          </div>
        </h3>
        <div className="relative flex flex-col md:flex-row items-center">
          <Dialog
            open={isDialogOpen}
            onClose={() => _setIsDialogOpen(false)}
            className="absolute w-80 h-96 z-10 right-1/2 bottom-1/2 translate-x-2/4 translate-y-2/4 border-2 border-b-blue-800"
          >
            <Dialog.Overlay />
            <Dialog.Title>Camera</Dialog.Title>
            <Dialog.Description></Dialog.Description>
            <button onClick={() => _setIsDialogOpen(false)}>Capture</button>
          </Dialog>
          <div className="bgWrapper md:flex justify-center items-center">
            <img src={SignupBg} alt="" />
          </div>
          <div className="pageContent w-full max-w-lg mx-auto md:mr-0 md:ml-auto mt-4 md:mt-0  mb-4 bg-white p-4 rounded-xl">
            <div className="hidden flex  md:flex">
              <IoMdArrowBack
                size={50}
                className="mr-3 cursor-pointer"
                onClick={() => goToHome()}
              />
              <div>
                <h1 className="text-2xl break-all font-subheading">Hi, {studentName}</h1>
                <h4 className={"hidden md:block text-2xl break-all font-subheading"}>
                  {"Edit your student profile"}
                </h4>
              </div>
            </div>

            <Blocks.ErrorBoundary>
              <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={UTILS.forms.editStudentProfile}
                onSubmit={updateProfile}
              >
                {({ handleSubmit, isSubmitting }) => (
                  <form onSubmit={handleSubmit} className="pt-6 pb-8">
                    {/* Display error message if exists */}
                    {errorMessage && (
                      <div className="mb-4 p-3 bg-red-100 border-l-4 border-red-500 text-red-700">
                        <p>{errorMessage}</p>
                      </div>
                    )}

                    <div className="md:grid md:grid-cols-2 gap-4">
                      <Field
                        type={"text"}
                        name="first_name"
                        placeholder="First Name"
                        iconBefore={
                          <i className={`text-xl icon icon-user`}></i>
                        }
                        component={Fields.FieldInput}
                      />
                      <Field
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        iconBefore={
                          <i className={`text-xl icon icon-user`}></i>
                        }
                        component={Fields.FieldInput}
                      />
                    </div>

                    <div className="md:grid md:grid-cols-2 gap-4">
                      <Field
                        type="text"
                        name="mobile_number"
                        placeholder="Mobile number"
                        iconBefore={
                          <i className={`text-xl icon icon-phone`}></i>
                        }
                        component={Fields.FieldInputPhoneNumber}
                      />
                      <Field
                        type="email"
                        name="email"
                        placeholder="Email Id"
                        iconBefore={
                          <i className={`text-xl icon icon-mail1`}></i>
                        }
                        component={Fields.FieldInput}
                        disabled={true}
                      />
                    </div>

                    <p className={"mb-2"}>Add further details</p>
                    <div className="md:grid md:grid-cols-2 gap-4">
                      <Field
                        type="date"
                        name="dob"
                        placeholder="Date of Birth"
                        iconBefore={<span className="italic font-bold">DOB</span>}Add commentMore actions
                        max={moment().format("YYYY-MM-DD")}
                        component={Fields.FieldInput}
                      />
                      <Field
                        name="gender"
                        options={[
                          { value: "male", label: "Male" },
                          { value: "female", label: "Female" },
                        ]}
                        component={Fields.FieldSelect}
                      />
                    </div>

                    <Field
                      name={"photo"}
                      component={Fields.FieldCameraInput}
                      isFileUpload
                    />
                    <button
                      disabled={isLoading}
                      className="bg-black w-full hover:bg-zinc-700 text-white inline-flex justify-center font-bold py-3 px-4 rounded focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                      type="submit"
                    >
                      {isLoading && <Partials.PartialLoading />}
                      Save Changes
                    </button>
                  </form>
                )}
              </Formik>
            </Blocks.ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageEditStudentProfile;